// extracted by mini-css-extract-plugin
module.exports =  {"breakpoints":"\"client/styles/viewports.module.css\"","m":"(min-width: 48rem)","searchIcon":"header__D0AmM54ansZy8vWGooYC"};